<section>
    <div id="slider">
      <div id="headerSlider" class="carousel slide" data-ride="carousel">
        <!-- <ol class="carousel-indicators">
          <li data-target="#headerSlider" data-slide-to="0" class="active"></li>
  
        </ol> -->
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img alt="" src="../assets/images/banner1.jpg" class="d-block w-100" />
            <div class="carousel-caption">
              <div class="banner-text">
                <!-- <h4 class="">Our Three Pillars</h4> -->
                <!-- <h5>STRIDE &middot; STRIVE &middot; SOAR</h5> -->
                <h2>Commercial Listings</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="pt-5 pb-5">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <!-- <h1 class="heading text-center">Stride Listings</h1> -->
            </div>
            <ng-container *ngFor="let listing of listings">
                <div class="col-md-4 pb-3">
                    <div
                        id="carouselExampleIndicators"
                        class="carousel slide"
                        data-ride="carousel"
                    >
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <img
                                    class="d-block w-100 listing-img"
                                    src="{{ listing.photos[1] }}"
                                    alt="Image Not Available"
                                />
                                <div class="carousel-caption d-md-block">
                                    <div class="listing-details">
                                        <h5>
                                            {{
                                                getPrice(listing.listPrice)
                                            }}
                                        </h5>
                                        <p>
                                            {{
                                                listing.address.full +
                                                    ", " +
                                                    listing.address.city +
                                                    ", " +
                                                    listing.address.state
                                            }}
                                        </p>
                                        <p class="room_details">
                                            {{
                                                listing.property.bedrooms
                                            }}
                                            bds |
                                            {{
                                                listing.property.bathrooms
                                            }}
                                            bths |
                                            {{ listing.property.area }} sqft
                                        </p>
                                        <p>
                                            <a [routerLink]="getListingPageID(listing.listingId)">More Details</a>
                                         </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            
        </div>
    </div>
</section>